import { io, type Socket } from 'socket.io-client'
import type { MeetingInviteEvent } from '@ai-meeting/shared'
import { API_BASE } from './api'
import { getAccessToken } from './session'

/** Must match `MEETING_INVITED_EVENT` on the gateway. */
export const MEETING_INVITED_EVENT = 'meeting.invited'

/** Must match `MEETING_INVITES_SYNC` on the gateway. */
export const MEETING_INVITES_SYNC = 'invites.sync'

/** How long to wait for a sync ack before letting the join through anyway. */
export const INVITE_SYNC_TIMEOUT_MS = 4_000

/**
 * Opens the invite channel for the signed-in user (BRAI-533).
 *
 * The socket carries no subscribe step: the server joins it to the room named
 * by the JWT it just verified, so the only invites it can ever receive are this
 * user's. `autoConnect: false` so the caller decides when to connect — the hook
 * waits until there is a token to send.
 */
export function createMeetingInviteSocket(): Socket {
  return io(`${API_BASE}/meeting-invites`, {
    autoConnect: false,
    transports: ['websocket'],
    auth: { token: getAccessToken() },
  })
}

export type { MeetingInviteEvent }
